import {
    FCACCEPT_V2_BASICS,
    FCACCEPT_V2_BOOKMARKS,
    FCACCEPT_V2_CLUBMEMBERS,
    FCACCEPT_V2_FRIENDS,
    FCACCEPT_V2_MODELS,
    FCACCEPT_V2_NONE,
    FCACCEPT_V2_PREMIUMS,
    FCACCEPT_V2_TOPFRIENDS,
} from '../mfcLogic/mfcConstants'

export const PRIVACY_VALUES = {
    NO_MESSAGES: FCACCEPT_V2_NONE,
    FRIENDS: FCACCEPT_V2_FRIENDS,
    MODELS: FCACCEPT_V2_MODELS,
    PREMIUM_MEMBERS: FCACCEPT_V2_PREMIUMS,
    BASIC_MEMBERS: FCACCEPT_V2_BASICS,
    BOOKMARKS: FCACCEPT_V2_BOOKMARKS,
    TOP_FRIENDS: FCACCEPT_V2_TOPFRIENDS,
    // this does not appear to be enabled on mobile.mfc
    // so they are not immediately enabled on app.mfc
    CLUB_MEMBERS: FCACCEPT_V2_CLUBMEMBERS,
} as const
